// extracted by mini-css-extract-plugin
export default {"inactive":"i4k7FxJ0cnK8k4lTJmZJ"};